import React, { useEffect, useState } from "react";
import Helpers from "../Helper/Helpers";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  // Dummy data for now, you can replace this with data fetched from your backend
  const [Products, setProducts] = useState(0);
  let email = localStorage.getItem("email");
  const [totalUsers, setTotalUsers] = useState(0);

  // Helper function to format numbers as rupees

  const [allData, setAllReviewData] = useState([]);
  const [order, setOrder] = useState([]);
  const [contactusers, setContactUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [banners, setBanners] = useState([]);
  const navigate = useNavigate();
  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = allData.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < Math.ceil(allData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    FetchAllReview();
    fetchAllOrders();
    fetchProducts();
  }, []);

  // const FetchAllUser = async () => {
  //   try {
  //     const res = await Helpers("/admin/allregisteruser", "GET");
  //     if (res && res?.status) {
  //       setUsers(res?.data);
  //       // console.log("fdfdfdfdfd", res?.data);
  //     } else {
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const FetchAllReview = async () => {
    try {
      const res = await Helpers("/admin/contact/get", "GET");
      if (res && res?.status) {
        setContactUsers(res?.data?.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllOrders = async () => {
    const res = await Helpers(`/admin/order/`, "GET");
    if (res && res?.status) {
      setOrder(res?.data);
    } else {
    }
  };

  useEffect(() => {
    FetchAllBanner();
  }, []);

  const FetchAllBanner = async () => {
    try {
      const res = await Helpers("/admin/banner/get", "GET");
      if (res && res?.status) {
        setBanners(res?.data?.reverse());
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await Helpers("/admin/product/get", "GET");
      if (res && res.status) {
        setProducts(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>

      {/* Dashboard Metrics */}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 mb-6">
        {/* Total Products */}
        <div
          className="bg-white shadow-md rounded-lg p-6"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/admin/order")}
        >
          <h2 className="text-xl font-semibold mb-2">Total Number of Orders</h2>
          <p className="text-3xl">{order?.length > 0 ? order?.length : 0}</p>
        </div>

        {/* Total Users */}
        <div
          className="bg-white shadow-md rounded-lg p-6"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/admin/product")}
        >
          <h2 className="text-xl font-semibold mb-2">
            {" "}
            Total Number of Products
          </h2>
          <p className="text-3xl">
            {Products?.length > 0 ? Products?.length : 0}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
        {/* Total Products */}
        <div
          className="bg-white shadow-md rounded-lg p-6"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/admin/contact")}
        >
          <h2 className="text-xl font-semibold mb-2">
            Total Number of Inquiry
          </h2>
          <p className="text-3xl">
            {contactusers?.length > 0 ? contactusers?.length : 0}
          </p>
        </div>

        <div
          className="bg-white shadow-md rounded-lg p-6"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/admin/contact")}
        >
          <h2 className="text-xl font-semibold mb-2">
            Total Number of Banners
          </h2>
          <p className="text-3xl">
            {banners?.length > 0 ? banners?.length : 0}
          </p>
        </div>
      </div>

      {/* Recent Orders */}
    </div>
  );
};

export default Dashboard;
